import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-header-company"
}
const _hoisted_2 = { class: "page-header-image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "page-header-content" }
const _hoisted_5 = { class: "page-header-title" }
const _hoisted_6 = { class: "page-header-subtitle" }
const _hoisted_7 = {
  key: 1,
  class: "page-header-image"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "page-content" }
const _hoisted_10 = ["id", "onClick"]
const _hoisted_11 = { class: "block-controls" }
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = ["disabled", "onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "page-footer-content" }
const _hoisted_16 = { class: "page-footer-title" }
const _hoisted_17 = { class: "page-footer-subtitle" }
const _hoisted_18 = { class: "page-footer-page" }

import { Component, computed, onMounted, ref, watch } from "vue";
import { styleZoom } from "@/common/utils/style";
import { styleToNumber } from "@/common/utils/style";
import draggable from "vuedraggable";
// blocks
import BlockData from "./blocks/block-data.vue";
import TextBlock from "./blocks/text-block.vue";
import TableBlock from "./blocks/table-block.vue";
//type
import type { ReportPageType } from "@/common/types/report";
// components
import { svgIcon } from "@/common/components";

interface ComponentsTypes {
  component: Component;
  props: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'page',
  props: {
    avatar: {},
    company: {},
    footer: {},
    header: {},
    page: {},
    pageIndex: {},
    selectedBlock: {},
    zoom: {},
    print: { type: Boolean }
  },
  emits: [
  "block:move-down",
  "block:move-up",
  "block:remove",
  "block:select",
  "block:reorder",
  "block:update",
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const components = computed<{ [key: string]: ComponentsTypes }>(() => ({
  "block-data": {
    component: BlockData,
    props: {
      selectedBlock: props.selectedBlock,
      zoom: props.zoom,
    },
  },
  "block-text": {
    component: TextBlock,
    props: {
      selectedBlock: props.selectedBlock,
      zoom: props.zoom,
    },
  },
  "block-title": {
    component: TextBlock,
    props: {
      selectedBlock: props.selectedBlock,
      zoom: props.zoom,
    },
  },
  "block-table": {
    component: TableBlock,
    props: {
      selectedBlock: props.selectedBlock,
      zoom: props.zoom,
    },
  },
}));

const internalPage = ref<ReportPageType>({ ...props.page });

const AREA_PADDING = computed(() => {
  if (!internalPage.value.style.padding) return 0;

  return styleToNumber(internalPage.value.style.padding);
});

const AREA_WIDTH = computed(() => {
  if (!props.page.style.width) return 0;

  const pageWidth = styleToNumber(props.page.style.width);

  return pageWidth - AREA_PADDING.value * 2;
});

function getBlock(type: keyof typeof components.value): ComponentsTypes {
  return components.value[type];
}

function getBlockProps(type: keyof typeof components.value): any {
  return components.value[type].props;
}

watch(
  () => props.page,
  (newPage) => {
    internalPage.value = { ...newPage };
  },
);

onMounted(() => {
  internalPage.value = { ...props.page };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page", {
      print: props.print,
      has_header: __props.header?.visible && !__props.footer?.visible,
      has_footer: __props.footer?.visible && !__props.header?.visible,
    }]),
    style: _normalizeStyle(_unref(styleZoom)(internalPage.value.style, __props.zoom))
  }, [
    (__props.header?.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["page-header", {
          'no-image': !__props.avatar && !__props.company,
          'no-company': !__props.company && __props.avatar,
        }]),
          style: _normalizeStyle(
          _unref(styleZoom)(
            {
              'font-size': '16px',
            },
            __props.zoom,
          )
        )
        }, [
          (__props.company)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    src: __props.company.avatar?.base64,
                    alt: "Logo"
                  }, null, 8, _hoisted_3)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(__props.header.title), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(__props.header.subtitle), 1)
          ]),
          (__props.avatar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: __props.avatar.base64,
                  alt: "Logo"
                }, null, 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true)
        ], 6))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_unref(draggable), {
        modelValue: internalPage.value.blocks,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((internalPage.value.blocks) = $event)),
        "item-key": "id",
        class: "blocks-container",
        onEnd: _cache[2] || (_cache[2] = ($event: any) => (emit('block:reorder', $event))),
        handle: ".drag-handle"
      }, {
        item: _withCtx(({ element: block }) => [
          _createElementVNode("div", {
            id: `${__props.pageIndex}-${block.block_id}`,
            class: _normalizeClass(["block", {
              selected: __props.selectedBlock === block.block_id,
            }]),
            onClick: ($event: any) => (emit('block:select', { page_index: __props.pageIndex, block }))
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "block-btn",
                disabled: block.ordered === 0,
                onClick: _withModifiers(($event: any) => (emit('block:move-up', block.block_id)), ["stop"])
              }, " ↑ ", 8, _hoisted_12),
              _createElementVNode("button", {
                class: "block-btn",
                disabled: block.ordered === __props.page.blocks.length - 1,
                onClick: _withModifiers(($event: any) => (emit('block:move-down', block.block_id)), ["stop"])
              }, " ↓ ", 8, _hoisted_13),
              _createElementVNode("button", {
                class: "block-btn danger",
                title: "Remover",
                onClick: _withModifiers(($event: any) => (emit('block:remove', block.block_id)), ["stop"])
              }, [
                _createVNode(_unref(svgIcon), {
                  icon: "trash",
                  size: "1rem"
                })
              ], 8, _hoisted_14)
            ]),
            (getBlock(block.type))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(getBlock(block.type).component), _mergeProps({ key: 0 }, {
                  ...getBlockProps(block.type),
                  block: block,
                }, {
                  "onBlock:update": _cache[0] || (_cache[0] = ($event: any) => (emit('block:update', $event)))
                }), null, 16))
              : _createCommentVNode("", true)
          ], 10, _hoisted_10)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    (__props.footer?.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "page-footer",
          style: _normalizeStyle(
          _unref(styleZoom)(
            {
              position: 'absolute',
              bottom: `${AREA_PADDING.value}px`,
              left: `${AREA_PADDING.value}px`,
              width: `${AREA_WIDTH.value}px`,
              'font-size': '16px',
            },
            __props.zoom,
          )
        )
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(__props.footer.title), 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(__props.footer.subtitle), 1)
          ]),
          _createElementVNode("div", _hoisted_18, _toDisplayString(__props.pageIndex + 1), 1)
        ], 4))
      : _createCommentVNode("", true)
  ], 6))
}
}

})